import React from 'react';

export const BtnOrdenar = (props) => {
    return (
        <button
        className="button-action"
        onClick={() => props.onClickOrdenar()}
        title={props.title}
        style={{
            marginRight: ".25em",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "0.25em" // Espaço entre ícone e texto (opcional)
        }}
    >
        <i className="pi pi-sort-alt"></i>{props.label}
    </button>
    )
}